/* eslint-disable import/prefer-default-export */
import { MDText } from 'i18n-react';

import bankStatementAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/bank-statement.avif';
import bankStatementJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/bank-statement.jpg';
import bankStatementWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/bank-statement.webp';
import deathCertificateAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/death-certificate.avif';
import deathCertificateJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/death-certificate.jpg';
import deathCertificateWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/death-certificate.webp';
import defaultImageJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/default-image.jpg';
import drivingLicenceAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/driving-licence1.avif';
import drivingLicenceJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/driving-licence1.jpg';
import drivingLicenceWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/driving-licence1.webp';
import financeSettlementLetterAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/finance-settlement-letter.avif';
import financeSettlementLetterJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/finance-settlement-letter.jpg';
import financeSettlementLetterWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/finance-settlement-letter.webp';
import letterOfConsentAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/letter-of-consent.avif';
import letterOfConsentJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/letter-of-consent.jpg';
import letterOfConsentWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/letter-of-consent.webp';
import passportAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/passport.avif';
import passportJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/passport.jpg';
import passportWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/passport.webp';
import utilityBillAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/proof-of-address.avif';
import utilityBillJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/proof-of-address.jpg';
import utilityBillWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/proof-of-address.webp';
import solicitorsLetterAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/solicitors-letter.avif';
import solicitorsLetterJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/solicitors-letter.jpg';
import solicitorsLetterWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/solicitors-letter.webp';
import v5c1Avif from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c1.avif';
import v5c1Jpg from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c1.jpg';
import v5c1Webp from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c1.webp';
import v5c2Avif from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c2.avif';
import v5c2Jpg from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c2.jpg';
import v5c2Webp from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c2.webp';
import v5c3Avif from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c3.avif';
import v5c3Jpg from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c3.jpg';
import v5c3Webp from '../../../../../client/assets_seller/documentCapture/documentGuide/v5c3.webp';
import willAvif from '../../../../../client/assets_seller/documentCapture/documentGuide/will.avif';
import willJpg from '../../../../../client/assets_seller/documentCapture/documentGuide/will.jpg';
import willWebp from '../../../../../client/assets_seller/documentCapture/documentGuide/will.webp';
import { DOCUMENT_CAPTURE_ROUTE_NAMES, DOCUMENT_KINDS } from '../DocumentCapture.helpers';
import type { DocumentCaptureRouteNamesValue, DocumentKindsValue } from '../DocumentCapture.types';

import type { Input } from './pages/uploadImageReducer.types';
import LocalTexts from './UploadDocuments.texts.json';

const LocalT = new MDText(LocalTexts.pages);

export type UploadDocumentSection = {
  addAnotherPage: boolean;
  analytics: {
    cta: string;
    guidePages?: string[];
    homePage: string;
  };
  guides?: {
    avif: any;
    jpg: any;
    webp: any;
  }[];
  inputs: Input[];
  route: {
    name: DocumentCaptureRouteNamesValue;
  };
}

export const UploadDocumentSections: Record<DocumentKindsValue, UploadDocumentSection> = {
  [DOCUMENT_KINDS.DRIVING_LICENCE]: {
    addAnotherPage: false,
    analytics: {
      cta: 'driving_licence_cta',
      guidePages: ['driving_licence_guide_page'],
      homePage: 'driving_licence_homepage',
    },
    guides: [
      {
        avif: drivingLicenceAvif,
        jpg: drivingLicenceJpg,
        webp: drivingLicenceWebp,
      },
    ],
    inputs: [
      {
        kind: 'driving_licence',
        label: LocalT.translate('driving_licence.inputs.frontSide.label'),
        name: 'driving_licence',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_DRIVING_LICENCE,
    },
  },
  [DOCUMENT_KINDS.V5]: {
    addAnotherPage: false,
    analytics: {
      cta: 'v5_cta',
      guidePages: [
        'v5_guide_page', 'v5_guide_page_2', 'v5_guide_page_3',
      ],
      homePage: 'v5_homepage',
    },
    guides: [
      {
        avif: v5c1Avif,
        jpg: v5c1Jpg,
        webp: v5c1Webp,
      },
      {
        avif: v5c2Avif,
        jpg: v5c2Jpg,
        webp: v5c2Webp,
      },
      {
        avif: v5c3Avif,
        jpg: v5c3Jpg,
        webp: v5c3Webp,
      },
    ],
    inputs: [
      {
        kind: 'v5',
        label: LocalT.translate('v5.inputs.1stPage.label'),
        name: 'v5_page',
        pageNumber: 1,
      },
      {
        kind: 'v5',
        label: LocalT.translate('v5.inputs.2ndPage.label'),
        name: 'v5_page_2',
        pageNumber: 2,
      },
      {
        kind: 'v5',
        label: LocalT.translate('v5.inputs.3rdPage.label'),
        name: 'v5_page_3',
        pageNumber: 3,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_V5,
    },
  },
  [DOCUMENT_KINDS.DEATH_CERTIFICATE]: {
    addAnotherPage: true,
    analytics: {
      cta: 'death_certificate_cta',
      guidePages: ['death_certificate_guide_page'],
      homePage: 'death_certificate_homepage',
    },
    guides: [
      {
        avif: deathCertificateAvif,
        jpg: deathCertificateJpg,
        webp: deathCertificateWebp,
      },
    ],
    inputs: [
      {
        kind: 'death_certificate',
        label: LocalT.translate('death_certificate.inputs.1stPage.label'),
        name: 'death_certificate_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_DEATH_CERTIFICATE,
    },
  },
  [DOCUMENT_KINDS.FINANCE_SETTLEMENT_LETTER]: {
    addAnotherPage: true,
    analytics: {
      cta: 'finance_settlement_letter_cta',
      guidePages: ['finance_settlement_letter_guide_page'],
      homePage: 'finance_settlement_letter_homepage',
    },
    guides: [
      {
        avif: financeSettlementLetterAvif,
        jpg: financeSettlementLetterJpg,
        webp: financeSettlementLetterWebp,
      },
    ],
    inputs: [
      {
        kind: 'finance_settlement_letter',
        label: LocalT.translate('finance_settlement_letter.inputs.1stPage.label'),
        name: 'finance_settlement_letter_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_FINANCE_SETTLEMENT_LETTER,
    },
  },
  [DOCUMENT_KINDS.PROOF_OF_PURCHASE]: {
    addAnotherPage: true,
    analytics: {
      cta: 'proof_of_purchase_cta',
      homePage: 'proof_of_purchase_homepage',
    },
    guides: undefined,
    inputs: [
      {
        kind: 'proof_of_purchase',
        label: LocalT.translate('proof_of_purchase.inputs.1stPage.label'),
        name: 'proof_of_purchase_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_PROOF_OF_PURCHASE,
    },
  },
  [DOCUMENT_KINDS.BANK_STATEMENT]: {
    addAnotherPage: true,
    analytics: {
      cta: 'bank_statement_cta',
      guidePages: ['bank_statement_guide_page'],
      homePage: 'bank_statement_homepage',
    },
    guides: [
      {
        avif: bankStatementAvif,
        jpg: bankStatementJpg,
        webp: bankStatementWebp,
      },
    ],
    inputs: [
      {
        analytics: {
          label: 'bank_statement_guide_page',
        },
        kind: 'bank_statement',
        label: LocalT.translate('bank_statement.inputs.1stPage.label'),
        name: 'bank_statement_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_BANK_STATEMENT,
    },
  },
  [DOCUMENT_KINDS.UTILITY_BILL]: {
    addAnotherPage: true,
    analytics: {
      cta: 'utility_bill_cta',
      guidePages: ['utility_bill_guide_page'],
      homePage: 'utility_bill_homepage',
    },
    guides: [
      {
        avif: utilityBillAvif,
        jpg: utilityBillJpg,
        webp: utilityBillWebp,
      },
    ],
    inputs: [
      {
        kind: 'utility_bill',
        label: LocalT.translate('utility_bill.inputs.1stPage.label'),
        name: 'utility_bill_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_PROOF_OF_ADDRESS,
    },
  },
  [DOCUMENT_KINDS.LETTER_OF_CONSENT]: {
    addAnotherPage: true,
    analytics: {
      cta: 'letter_of_consent_cta',
      guidePages: ['letter_of_consent_guide_page'],
      homePage: 'letter_of_consent_homepage',
    },
    guides: [
      {
        avif: letterOfConsentAvif,
        jpg: letterOfConsentJpg,
        webp: letterOfConsentWebp,
      },
    ],
    inputs: [
      {
        analytics: {
          label: 'letter_of_consent_guide_page',
        },
        kind: 'letter_of_consent',
        label: LocalT.translate('letter_of_consent.inputs.1stPage.label'),
        name: 'letter_of_consent_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_LETTER_OF_CONSENT,
    },
  },
  [DOCUMENT_KINDS.WILL]: {
    addAnotherPage: true,
    analytics: {
      cta: 'will_cta',
      guidePages: ['will_guide_page'],
      homePage: 'will_homepage',
    },
    guides: [
      {
        avif: willAvif,
        jpg: willJpg,
        webp: willWebp,
      },
    ],
    inputs: [
      {
        kind: 'will',
        label: LocalT.translate('will.inputs.1stPage.label'),
        name: 'will_page',
        pageNumber: 1,

      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_WILL,
    },
  },
  [DOCUMENT_KINDS.SOLICITORS_LETTER]: {
    addAnotherPage: true,
    analytics: {
      cta: 'solicitors_cta',
      guidePages: ['solicitors_guide_page'],
      homePage: 'solicitors_homepage',
    },
    guides: [
      {
        avif: solicitorsLetterAvif,
        jpg: solicitorsLetterJpg,
        webp: solicitorsLetterWebp,
      },
    ],
    inputs: [
      {
        kind: 'solicitors_letter',
        label: LocalT.translate('solicitors_letter.inputs.1stPage.label'),
        name: 'solicitors_letter_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_SOLICITORS_LETTER,
    },
  },
  [DOCUMENT_KINDS.PASSPORT]: {
    addAnotherPage: true,
    analytics: {
      cta: 'passport_cta',
      guidePages: ['passport_guide_page'],
      homePage: 'passport_homepage',
    },
    guides: [
      {
        avif: passportAvif,
        jpg: passportJpg,
        webp: passportWebp,
      },
    ],
    inputs: [
      {
        kind: 'passport',
        label: LocalT.translate('passport.inputs.1stPage.label'),
        name: 'passport_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_PASSPORT,
    },
  },
  [DOCUMENT_KINDS.ADDITIONAL_DOCUMENTS]: {
    addAnotherPage: true,
    analytics: {
      cta: 'additional_documents_cta',
      guidePages: ['additional_documents_guide_page'],
      homePage: 'additional_documents_homepage',
    },
    inputs: [
      {
        kind: 'additional_documents',
        label: LocalT.translate('additional_documents.inputs.1stPage.label'),
        name: 'additional_documents_page',
        pageNumber: 1,
      },
    ],
    route: {
      name: DOCUMENT_CAPTURE_ROUTE_NAMES.UPLOAD_ADDITIONAL_DOCUMENTS,
    },
  },
};

export const defaultGuideImage = [
  {
    jpg: defaultImageJpg,
  },
];
